import { css } from 'emotion';
import theme from '@lyearn-team/theme-config';

const root = css`
  height: 100%;
`;

const fixedTitle = () => css`
  padding-top: 74px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.9px;
  color: ${theme.color.white};
  opacity: 0.6;
  margin-bottom: 8px;
`;

const exitButtonContainer = () => css`
  height: 74px;
  background-color: ${theme.color.dark.uranus};
`;

const title = () => css`
  font-size: 32px;
  line-height: normal;
  color: ${theme.color.white};
  margin-bottom: 16px;
  max-width: 600px;
  text-align: center;
`;

const sessions = () => css`
  color: ${theme.color.white};
  font-size: 16px;
  line-height: normal;
  margin-bottom: 36px;
  display: inline-flex;
  align-items: center;
`;

const divider = () => css`
  width: 30% !important;
  color: ${theme.color.white};
  opacity: 0.3;
  margin-bottom: 30px;
`;

const description = () => css`
  opacity: 0.7;
  line-height: 1.25;
  font-size: 16px;
  color: ${theme.color.white};
  margin-bottom: 48px;
  max-width: 600px;
  text-align: center;
  padding: 0 20px;
`;

const seperatator = () => css`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.4);
`;

const viewBadge = () => css`
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: ${theme.color.black2};
  fill: ${theme.color.black2};
  border-radius: 4px;
  background-color: ${theme.color.grey4};
  cursor: pointer;
  height: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 0 5px;

  .icon {
    margin-right: 3px;
    fill: inherit;
  }
`;

const zoomBtn = css`
  fill: white;
  position: absolute;
  right: 8px;
  &.zoom {
    right: 38px;
  }
  top: calc(3rem + 8px);
  z-index: 2;
  background: ${theme.color.dark.uranus};
  :hover {
    background: ${theme.color.dark.uranus} !important;
  }
  opacity: 0.4;
  border-radius: 3px;
  @media (max-width: 767px) {
    width: 32px;
    height: 32px;
    right: 8px;
    top: calc(3rem + 8px);
    &.zoom {
      right: 20px;
      top: 20px;
    }
  }
`;

const previewHTMLContainer = css`
  padding: 40px;
  margin-top: 40px;
  padding-top: 40px !important;
`;

const switchLabel = left => css`
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;

  ${left &&
    css`
      margin-right: 12px !important;
    `}
`;

const toggleSwitch = css`
  width: 24px;
`;

const switchContainer = css`
  .react-toggle-track {
    width: 21px !important;
    height: 10px !important;
  }
  .react-toggle:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${theme.color.dark.copper} !important;
  }
  .react-toggle--checked:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${theme.color.dark.earth} !important;
  }
  .react-toggle.small.react-toggle--checked .react-toggle-thumb {
    left: 12px !important;
    background-color: ${theme.color.dark.copper}!important;
  }
  .react-toggle--focus .react-toggle-thumb {
    box-shadow: none !important;
  }
  .react-toggle.small .react-toggle-thumb {
    height: 12px !important;
    width: 12px !important;
    background-color: ${theme.color.dark.saturn}!important;
    top: -1px !important;
    left: -3px !important;
  }
`;

export default {
  root,
  fixedTitle,
  exitButtonContainer,
  title,
  sessions,
  divider,
  description,
  seperatator,
  viewBadge,
  zoomBtn,
  previewHTMLContainer,
  switchLabel,
  toggleSwitch,
  switchContainer
};
